import {
  useAllDisplayGroups,
  useAllIngredients,
  useAllProductCategories,
  useAllProducts,
  useAllTags,
  useAllVatRates,
  useConciseProductMenu,
  useDefaultProductMenu,
} from '../../../apis/products-api';

export const useProductData = () => {
  const {
    data: products,
    isInitialLoading: isInitialLoadingProducts,
    isFetching: isFetchingProducts,
  } = useAllProducts();

  const {
    data: productCategories,
    isInitialLoading: isInitialLoadingCategories,
    isFetching: isFetchingCategories,
  } = useAllProductCategories();

  const {
    data: displayGroups,
    isInitialLoading: isInitialLoadingDisplayGroups,
    isFetching: isFetchingDisplayGroups,
  } = useAllDisplayGroups();

  const {
    data: allIngredients,
    isInitialLoading: isInitialLoadingIngredients,
    isFetching: isFetchingIngredients,
  } = useAllIngredients();

  const {
    data: defaultMenu,
    isInitialLoading: isInitialLoadingDefaultMenu,
    isFetching: isFetchingDefaultMenu,
  } = useDefaultProductMenu();

  const {
    data: conciseMenu,
    isInitialLoading: isInitialLoadingConciseMenu,
    isFetching: isFetchingConciseMenu,
  } = useConciseProductMenu();

  const {
    data: allVatRates,
    isInitialLoading: isInitialLoadingVatRates,
    isFetching: isFetchingVatRates,
  } = useAllVatRates();

  const { data: tags, isInitialLoading: isInitialLoadingTags, isFetching: isFetchingTags } = useAllTags();

  const isInitialLoading =
    isInitialLoadingProducts ||
    isInitialLoadingCategories ||
    isInitialLoadingDisplayGroups ||
    isInitialLoadingIngredients ||
    isInitialLoadingDefaultMenu ||
    isInitialLoadingConciseMenu ||
    isInitialLoadingVatRates ||
    isInitialLoadingTags;

  const isFetching =
    isFetchingProducts ||
    isFetchingCategories ||
    isFetchingDisplayGroups ||
    isFetchingIngredients ||
    isFetchingDefaultMenu ||
    isFetchingConciseMenu ||
    isFetchingVatRates ||
    isFetchingTags;

  return {
    products,
    productCategories,
    displayGroups,
    allIngredients,
    defaultMenu,
    conciseMenu,
    allVatRates,
    tags,
    isInitialLoading,
    isFetching,
  };
};
